import { FC } from 'react'

export const MagnifyingGlass: FC<{ className: string }> = ({ className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 16 17'
    className={className}
  >
    <path
      d='M7.0448 2.72974C9.80943 2.73098 12.0227 4.94891 12.0346 7.71215C12.0383 8.60729 11.8246 9.43707 11.3811 10.2071C11.2652 10.4081 11.2877 10.5345 11.4478 10.692C12.1878 11.4197 12.9148 12.1592 13.6536 12.8881C13.9682 13.1988 14.1052 13.5598 13.9906 13.9893C13.7863 14.755 12.8457 14.9834 12.2451 14.4052C11.6247 13.8082 11.0248 13.1894 10.4137 12.5831C10.2156 12.3864 10.0393 12.12 9.79759 12.0266C9.53097 11.9233 9.30111 12.2196 9.04944 12.3273C5.9316 13.665 2.40325 11.6419 2.03136 8.29604C1.70057 5.31307 4.02851 2.72787 7.0448 2.72974ZM7.01179 4.2704C5.0383 4.34759 3.59681 5.80484 3.56878 7.73705C3.54137 9.61385 5.1467 11.2174 7.02238 11.1856C9.01268 11.1514 10.4903 9.64933 10.4735 7.7109C10.4573 5.71956 8.92921 4.32705 7.01179 4.2704Z'
      fill='#122D5C'
    />
  </svg>
)
